
/* ============================== src/components/ToggleSwitch.jsx ============================== */
// src/components/ToggleSwitch.jsx
/**
 * Тумблер «вкл / выкл» с подписью.
 * Добавлена поддержка пропса disabled для блокировки действий.
 */
export function ToggleSwitch({
  checked,
  onChange,
  label,
  className = "",
  disabled = false,
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={`toggle-switch${checked ? " on" : ""}${disabled ? " disabled" : ""}${className ? " " + className : ""}`}
      onClick={() => {
        if (!disabled) onChange(!checked);
      }}
      style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
    >
      <span className="toggle-switch-track" aria-hidden="true">
        <span className="toggle-switch-knob" />
      </span>
      <span className="toggle-switch-label">{label}</span>
    </button>
  );
}
